import React, { HTMLAttributes, useState } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import Search from 'atomic/search/search';
import Dropdown from 'atomic/dropdown/dropdown';
import Button from 'atomic/button/button';
import Svg from 'atomic/svg/svg';
import search from 'assets/icons/search.svg';

import './search.desktop.scss';

const SearchDesktop: React.FC<HTMLAttributes<HTMLElement>> = ({ className, ...props }) => {
    const searchQuery = useSelector(
        (state: { searchQuery: string; }) => state.searchQuery
    );

    const [query, setQuery] = useState(searchQuery);
    const [type, setType] = useState('shops');

    const handleTypeChange = (value: string | number): void => {
        setType(String(value));
    };

    const handleClick = (): void => {
        if (query && type) {
            window.location.assign(`/?szukaj=${encodeURIComponent(query)}&s=${type === 'shops' ? 1 : 2}`);
        }
    };

    return (
        <div className={className} {...props}>
            <Search
                className="header__search-search"
                name="search"
                url=""
                defaultValue={searchQuery}
                onQueryChange={setQuery}
                onSubmit={handleClick}
            />
            <Dropdown
                className="header__search-dropdown"
                name="dropdown"
                value="shops"
                readOnly={true}
                list={[{ value: 'shops', title: 'E-sklepy i Firmy' }, { value: 'products', title: 'Produkty' }]}
                showOnHover={true}
                onDropdownChange={handleTypeChange}
            />
            <Button className="header__search-button" wrapper={true} onClick={handleClick}>
                <Svg className="header__search-icon" path={search} width={24} />
            </Button>
        </div>
    );
};

export default SearchDesktop;
